import { render, staticRenderFns } from "./BreadCrumb.vue?vue&type=template&id=68dd5618&scoped=true"
import script from "./BreadCrumb.vue?vue&type=script&lang=js"
export * from "./BreadCrumb.vue?vue&type=script&lang=js"
import style0 from "./BreadCrumb.vue?vue&type=style&index=0&id=68dd5618&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68dd5618",
  null
  
)

export default component.exports